import { PolicyStatus } from 'constants/policy';
import {
  trackEvent,
  trackEventGetAdvice,
  TRACKING_EVENTS,
} from '../helpers/segment';
import { getDeviceType } from '../helpers/window';
import { getMarketScanReferenceProps } from '../helpers/storage';
import { hasAdditionalDrivers } from '../helpers/additionalDriver';
import { AppActionTypes } from '../redux/actions';
import { Types as PolicyTypes } from '../redux/actions/policy';

const gaLogger = (store) => (next) => (action: AppActionTypes) => {
  const result = next(action);
  switch (action.type) {
    case PolicyTypes.CREATE_POLICY_LOADED:
      // Do not track market scan holder policies
      if (action.data.status === PolicyStatus.MARKET_SCAN_HOLDER) {
        break;
      }

      if (action.data.isUpload) {
        trackEvent(TRACKING_EVENTS.PolicyAddedUpload, {
          policyType: action.data.policyType,
          policyProviderName: action.data.policyProviderName,
        });
      } else {
        trackEvent(TRACKING_EVENTS.PolicyAddedManual, {
          policyType: action.data.policyType,
          policyProviderName: action.data.policyProviderName,
        });
      }
      break;
    case PolicyTypes.CREATE_POLICY_SCAN_LOADED:
      trackEvent(TRACKING_EVENTS.MarketScanSubmitted, {
        ...action.data,
        hasAdditionalDrivers: hasAdditionalDrivers(action.data.additionalDrivers),
        deviceType: getDeviceType(),
        ...getMarketScanReferenceProps(),
      });
      trackEvent('AddToCart', action.data);
      break;
    case PolicyTypes.CREATE_POLICY_SCAN_WITHOUT_POLICY_LOADED:
      trackEvent(TRACKING_EVENTS.MarketScanNoPolicySubmitted, action.data);
      break;
    default:
      break;
  }

  return result;
};

export default gaLogger;
